import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import ChangePassword from './ChangePassword'
import { ChangePasswordViewModel } from '../../models/ChangePasswordViewModel'
import ChangePasswordConfirmation from './ChangePasswordConfirmation'
import ChangePasswordTokenExpired from './ChangePasswordTokenExpired'

export default class ChangePasswordUI extends Component {
    state = {
        showChangePassword:true
    }
    
    showConfirmation = () => {
        this.setState( { showChangePassword: false } )    
    }

    get config() {
        return this.props.config || {}
    }
    get changePasswordViewModel() {
        return this.config.changePasswordViewModel || { expirePasswordReset: false }
    }
    get expirePasswordReset() {
        return this.changePasswordViewModel.expirePasswordReset || false
    }

    render() {
        const { showChangePassword } = this.state
        return (
            <Fragment>
                { !this.expirePasswordReset ? 
                    showChangePassword
                        ? <ChangePassword showConfirmation={ this.showConfirmation } config={ this.props.config } />
                        : <ChangePasswordConfirmation  config={ this.props.config } />
                : <ChangePasswordTokenExpired  config={ this.props.config } />
                }
            </Fragment>
        )
    }
}

ChangePasswordUI.propTypes = {
    config: PropTypes.shape( {
        logInUrl: PropTypes.string,
        changePasswordUrlApiUrl: PropTypes.string,
        changePasswordViewModel: PropTypes.instanceOf( ChangePasswordViewModel )
    } )
}
